import { createTheme } from '@mui/material/styles';
export const bikes = [
  {
    id: 1,
    name: 'Royal Enfield Classic 350',
    description: 'A classic bike with a retro design and powerful engine.',
    imageUrl: 'images/bikes/r-enfield-350.webp',
    price: 800,
  },
  {
    id: 2,
    name: 'Bajaj Pulsar 220F',
    description: 'A performance bike with high speed and great handling.',
    imageUrl: 'images/bikes/b-pulsar-220f.jpeg',
    price: 700,
  },
  {
    id: 3,
    name: 'Honda Hornet 2.0',
    description: 'A reliable bike with a smooth ride, great for city rides.',
    imageUrl: 'images/bikes/h-hornet-2.jpeg',
    price: 750,
  },
];
export const cars = [
  {
    id: 1,
    name: 'New Fortuner Auto Facelift',
    price: 5800,
    imageUrl: 'images/cars/new-fortuner.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 7,
    type: 'Automatic',
  },
  {
    id: 2,
    name: 'Innova Hycross',
    price: 4000,
    imageUrl: 'images/cars/innova-hycross.jpeg',
    bodyType: 'MPV',
    seatingCapacity: 7,
    type: 'Automatic',
  },
  {
    id: 3,
    name: 'Innova Crysta Auto',
    price: 3500,
    imageUrl: 'images/cars/innova-crysta.jpeg',
    bodyType: 'MPV',
    seatingCapacity: 7,
    type: 'Automatic',
  },
  {
    id: 4,
    name: 'Thar Auto Convertible',
    price: 3500,
    imageUrl: 'images/cars/thar-convertible.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 4,
    type: 'Automatic',
  },
  {
    id: 5,
    name: 'Thar Hard Top Auto',
    price: 3500,
    imageUrl: 'images/cars/thar-hard-top.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 4,
    type: 'Automatic',
  },
  {
    id: 6,
    name: 'Thar Manual',
    price: 3200,
    imageUrl: 'images/cars/thar-hard-top.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 4,
    type: 'Manual',
  },
  {
    id: 7,
    name: 'Alcazar Auto with Panoramic Sunroof',
    price: 3500,
    imageUrl: 'images/cars/alcazar.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 6,
    type: 'Automatic',
  },
  {
    id: 8,
    name: 'New Creta Auto with Panoramic Sunroof',
    price: 3200,
    imageUrl: 'images/cars/creta.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 5,
    type: 'Automatic',
  },
  {
    id: 9,
    name: 'New Crysta Manual',
    price: 3000,
    imageUrl: 'images/cars/innova-crysta.jpeg',
    bodyType: 'MPV',
    seatingCapacity: 7,
    type: 'Manual',
  },
  {
    id: 10,
    name: 'New Ertiga Auto',
    price: 3000,
    imageUrl: 'images/cars/ertiga.jpeg',
    bodyType: 'MPV',
    seatingCapacity: 7,
    type: 'Automatic',
  },
  {
    id: 11,
    name: 'New Ertiga Manual',
    price: 2500,
    imageUrl: 'images/cars/ertiga.jpeg',
    bodyType: 'MPV',
    seatingCapacity: 7,
    type: 'Manual',
  },
  {
    id: 12,
    name: 'New i20 Auto',
    price: 1600,
    imageUrl: 'images/cars/i20.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Automatic',
  },
  {
    id: 13,
    name: 'New i20 Manual',
    price: 1400,
    imageUrl: 'images/cars/i20.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Manual',
  },
  {
    id: 14,
    name: 'New Baleno Auto',
    price: 1500,
    imageUrl: 'images/cars/baleno.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Automatic',
  },
  {
    id: 15,
    name: 'New Baleno Manual',
    price: 1200,
    imageUrl: 'images/cars/baleno.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Manual',
  },
  {
    id: 16,
    name: 'Grand i10 Manual',
    price: 1200,
    imageUrl: 'images/cars/i10.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Manual',
  },
  {
    id: 17,
    name: 'Grand i10 Auto',
    price: 1400,
    imageUrl: 'images/cars/i10.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Automatic',
  },
  {
    id: 18,
    name: 'New Swift Auto',
    price: 1500,
    imageUrl: 'images/cars/swift.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Automatic',
  },
  {
    id: 19,
    name: 'New Swift Manual',
    price: 1400,
    imageUrl: 'images/cars/swift.jpeg',
    bodyType: 'Hatchback',
    seatingCapacity: 5,
    type: 'Manual',
  },
  {
    id: 20,
    name: 'Old Shape Thar Manual 6-Seater',
    price: 2500,
    imageUrl: 'images/cars/old-shape-thar.jpeg',
    bodyType: 'SUV',
    seatingCapacity: 6,
    type: 'Manual',
  }
];

  export const scooties = [
    {
      id: 1,
      name: 'Fascino',
      imageUrl: 'images/scooties/fascino.webp',
      price: 400,
      bodyType: 'Scooter',
      seatingCapacity: 2,
      type: 'Regular'
    },
    {
      id: 2,
      name: 'Activa',
      imageUrl: 'images/scooties/h-activa.webp',
      price: 400,
      bodyType: 'Scooter',
      seatingCapacity: 2,
      type: 'Regular'
    }
  ];


  export const buttons = [
    { label: "See All Cars", name: 'cars' },
    { label: "See All Scooties", name: 'scooties' },
  ];

export const imageUrl='/images'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#352f44',
    },
    secondary: {
      main: '#4caf50',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'white',
          backgroundColor: '#352f44',
          '&:hover': {
            backgroundColor: '#393e46',
          },
        },
      },
    },
  },
});


